<template>
  <v-form v-model="isFormValid" @submit.prevent="onSubmit">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.year"
          label="Year"
          type="number"
          :rules="[rules.required]"></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.fieldInputStartDate"
          label="Start Date"
          type="date"
          :rules="[rules.required]"
          required></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.fieldInputEndDate"
          label="End Date"
          type="date"
          :rules="[rules.required]"
          required></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.fieldInputLaunchDate"
          label="Launch Date"
          type="datetime-local"></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.fieldInputTurnStart"
          label="Turn-In Start Date"
          type="datetime-local"></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.fieldInputTurnDeadline"
          label="Turn-In Deadline"
          type="datetime-local"></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field
          v-model="year.fieldInputScreeningCopyDeadline"
          label="Screening Copy Deadline"
          type="datetime-local"></v-text-field>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="year.theme" label="Theme"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Overview Text
        <Editor
          v-model="year.turn_in_overview_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Upload Text
        <Editor
          v-model="year.turn_in_upload_movie_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Upload Late Text
        <Editor
          v-model="year.turn_in_upload_movie_late"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Screening Copy Text
        <Editor
          v-model="year.turn_in_upload_screening_copy_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Entry Text
        <Editor
          v-model="year.turn_in_entry_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Criteria Text
        <Editor
          v-model="year.turn_in_criteria_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Still/Team Video Text
        <Editor
          v-model="year.turn_in_still_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Release Form Text
        <Editor
          v-model="year.turn_in_release_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Turn In Cast and Crew Text
        <Editor
          v-model="year.turn_in_cast_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Criteria FAQ Text
        <Editor
          v-model="year.criteria_faq"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        Criteria Selection Text
        <Editor
          v-model="year.criteria_selection_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        Registration Text
        <Editor
          v-model="year.registration_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        Registration Level Text
        <Editor
          v-model="year.registration_level_text"
          :init="{
            base_url: '/tinymce',
            suffix: '.min',
            plugins: 'lists link image table code',
            toolbar:
              'undo redo | blocks | bold italic | alignleft aligncenter alignright | bullist numlist | link image table | code',
            skin: 'oxide',
            content_css: 'default',
          }"
          licenseKey="gpl"></Editor>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <v-checkbox
          label="Allow Teams to Select Optional Criteria"
          :model-value="year.allow_optional_criteria"></v-checkbox>
      </v-col>
    </v-row>
    <v-btn
      :loading="isSubmitting"
      color="primary"
      block
      class="rounded-lg mb-8"
      elevation="2"
      @click="onSubmit"
      >{{ saveLabel }}</v-btn
    >
  </v-form>
</template>
<script setup lang="ts">
import { IYearDTO, YearDTO } from '@/dtos';
import { rules } from '@/helpers';
import { useYearStore } from '@/stores';
import Editor from '@tinymce/tinymce-vue';
import { computed, ref, toRef } from 'vue';
interface Props {
  year: IYearDTO;
  isCreate?: boolean;
}
const props = defineProps<Props>();
const year = ref<IYearDTO>(new YearDTO(props.year));
const isCreate = toRef(props, 'isCreate', false);
const emit = defineEmits(['yearEditCompleted', 'yearEditCancelled']);
import '@/components/tinymce/tinymce';
const isFormValid = ref<boolean | null>(false);
const isSubmitting = ref<boolean | undefined>(false);

const yearStore = useYearStore();
const onSubmit = async () => {
  if (!year.value) {
    return;
  }
  isSubmitting.value = true;
  if (!isCreate.value) {
    yearStore.update.mutateAsync(year.value);
  } else {
    yearStore.create.mutateAsync(year.value);
  }

  emit('yearEditCompleted');
  isSubmitting.value = false;
};

const saveLabel = computed(() => {
  if (isCreate.value == true) {
    return 'Create Year';
  } else {
    return 'Save';
  }
});
</script>
